import React from 'react';
import {
  Box,
  Container
} from '@chakra-ui/react';
import Seo from '../../components/sections/seo';


/**
 * TODO: Currently there is no content.
 * To be filled in at a later time
 */
import HeadingWithText from '../../components/sections/headingwithtext'

export default function PranaTabPanel() {
  return (
    <Box>
      <Seo
        title="Leadership at prAna"
        description="Executive leadership at prAna."
        //links={[{"rel": "canonical", "href": "https://www.columbiasportswearcompany.com/careers"}]}
      />
      <Container maxW='6xl' my={14} className='flow'>
        <HeadingWithText
          title="COMING SOON..."
        ></HeadingWithText>
      </Container>
    </Box>
  );
}
